import React, { useCallback, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import Close from '@material-ui/icons/Close';
import ForwardIcon from '@material-ui/icons/ArrowForwardIos';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { Portal } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: 10001,
        opacity: 1,
        background: '#000',
        color: '#f0f0f0',
        height: 'fit-content',
        minHeight: '100vh'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
        color: '#cfcfcf',
        '& button:hover': {
            background: "#333",
            color: '#fff'
        }
    },
    movementButton: {
        position: 'absolute',
        height: '100%',
        width: '10%',
        color: '#cfcfcf',
        '& button': {
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            borderRadius: 0,
        },
        '& button:hover': {
            color: '#fff'
        },
    },
    forwardButton: {
        right: 0,
        top: 0
    },
    backButton: {
        left: 0,
        top: 0,
        '& button': {
            textAlign: 'right'
        }
    },
    root: {
        height: 'calc(100% - 160px)',
        width: '100%',
        position: 'relative',
    },
    viewport: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        //marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    image: {
        objectFit: 'cover',
        overflow: 'hidden',
        borderRadius: 6,
        cursor: 'pointer',
        maxHeight: '100%',
    },
    imageContainer: {
        position: 'relative',
        display: 'inline',
    },
    thumbs: {
        display: 'flex',
        overflow: 'hidden',
        '& > :first-child': { marginLeft: 'auto' },
        '& > :last-child': { marginRight: 'auto' },
        '& > :not(:last-child)': {
            marginRight: theme.spacing(1),
        }
    },
    thumb: {
        '& img': {
            borderRadius: theme.shape.borderRadius,
            overflow: 'hidden',
            objectFit: 'cover',
            width: 72,
            height: 72,
            filter: 'brightness(.4)',
            transition: '.3s filter linear, .3s -webkit-filter linear',
            cursor: 'pointer',
        },
    },
    thumbActive: {
        '& img': {
            filter: 'brightness(1)'
        },
    },
    description: {
        position: 'absolute',
        top: theme.spacing(3),
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        '& > *': {
            overflow: 'hidden',
            maxWidth: '50%',
        },
    },
}), { name: "Lightbox" });
function Thumbnails({ urls, index, onChange }) {
    const classes = useStyles();
    const scrollRef = useRef();
    useEffect(() => {
        if (!scrollRef.current)
            return;
        scrollRef.current.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }, [urls, index]);
    return React.createElement("div", { className: classes.thumbs }, urls.map((x, i) => React.createElement("div", { key: i, className: `${classes.thumb} ${i == index ? classes.thumbActive : ''}`, ref: ref => index == i ? scrollRef.current = ref : 0 },
        React.createElement("img", { src: x, onClick: () => index != i ? onChange(i) : 0 }))));
}
export default function Lightbox(props) {
    var _a;
    const classes = useStyles();
    const [imageIndex, setImageIndex] = useState((_a = props.initialIndex) !== null && _a !== void 0 ? _a : 0);
    const handleBackButtonClick = useCallback(() => {
        setImageIndex((x) => x - 1 >= 0 ? x - 1 : props.images.length - 1);
    }, []);
    const handleForwardButtonClick = useCallback(() => {
        setImageIndex((x) => x + 1 < props.images.length ? x + 1 : 0);
    }, [props.images]);
    return React.createElement(Portal, { container: document.body },
        React.createElement(Backdrop, { open: props.open, className: classes.backdrop },
            React.createElement("div", { className: classes.root },
                React.createElement("div", { className: classes.viewport }, imageIndex < props.images.length
                    ? React.createElement("img", { src: props.images[imageIndex].urls.original, className: classes.image, onClick: handleForwardButtonClick })
                    : null),
                React.createElement("div", { className: `${classes.movementButton} ${classes.backButton}` },
                    React.createElement(Button, { color: "inherit", onClick: handleBackButtonClick },
                        React.createElement(BackIcon, { fontSize: "large" }))),
                React.createElement("div", { className: `${classes.movementButton} ${classes.forwardButton}` },
                    React.createElement(Button, { color: "inherit", onClick: handleForwardButtonClick },
                        React.createElement(ForwardIcon, { fontSize: "large" }))),
                React.createElement(Thumbnails, { urls: props.images.map(x => x.urls.thumbnail), index: imageIndex, onChange: i => setImageIndex(i) })),
            React.createElement("div", { className: classes.closeButton },
                React.createElement(IconButton, { color: "inherit", onClick: props.onClose },
                    React.createElement(Close, { fontSize: "large" }))),
            React.createElement("div", { className: classes.description },
                React.createElement("span", null, props.images[imageIndex].description))));
}
